<template>
  <div style="padding: 0px 40px;">
    <el-row
      type="flex"
      justify="center"
      :gutter="32"
    >
      <el-col
        :sm="24"
      >
        <dashboard-section
          :title="$t($i18nLabelsHelper(orgType,'dashboard.class_overview'))"
        >
          <el-row
            type="flex"
            :gutter="32"
            
          >
            <el-col
              v-if="classes.length > 0"
              :xs="24"
              :md="6*classes.length"
            >
              <el-row
                type="flex"
                :gutter="32"
              >
                <dashboard-card
                  v-for="(clazz, idx) in classes"
                  :key="idx"
                  :xs="24"
                  :sm="24/classes.length"
                  class="dashboard-card"
                >
                  <div class="class-card-heading">
                    <h3>{{clazz.name}}</h3>
                      <p
                        class="link"
                        @click="handleClassDetails(clazz.id)"
                      >
                        {{ $t($i18nLabelsHelper(orgType, 'dashboard.view_class')) }}
                      </p>
                  </div>
                  <class-progress
                    :classData="clazz"
                  />
                  <div class="class-summary">
                    <img src="@/assets/images/students-class.svg">
                    <div>
                      <span class="student-number">{{clazz.users_count}}</span>
                      <span class="students">{{ $t($i18nLabelsHelper(orgType, 'students')) }}</span>
                    </div>
                  </div>
                </dashboard-card>
              </el-row>
            </el-col>

            <el-col
              :md="6"
              :xs="24"
              class="other-classes"
            >
              <div>
                <img src="@/assets/images/class-blue.svg">
                <div>
                  <span class="class-number">{{classesLength}}</span>
                  <div class="classes-students">
                    <span class="classes">{{ $t($i18nLabelsHelper(orgType, 'students')) }}</span>
                      <router-link
                        :to="{ 
                          name: 'students',
                          params: { organizationId: currentOrganizationId }
                        }"
                      >
                        {{ $t('classes.classes_details.overview_section.view_list') }}
                      </router-link>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </dashboard-section>
      </el-col>
    </el-row>
    <!-- <el-row
      :gutter="32"
    >
      <el-col
        :sm="20"
      >
        <dashboard-section
          :title="$t('dashboard.reports_overview')"
        >

        </dashboard-section>
      </el-col>
      <el-col
        :sm="4"
      >
        <dashboard-section
            :title="$t('dashboard.notifications')"
          >

        </dashboard-section>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
  import DashboardCard from '@/components/dashboard/DashboardCard'
  import DashboardSection from '@/components/dashboard/DashboardSection'
  import ClassProgress from '@/components/common/ClassProgress'
  import { mapGetters, mapActions } from 'vuex'
  import {
    compose,
    length,
    propOr,
    slice,
  } from 'ramda'
  import { warningMessage } from '../../utils/messages'

  export default {
    components: {
      DashboardCard,
      DashboardSection,
      ClassProgress,
    },
    methods: {
      handleClassDetails(groupId) {
        this.getClass({
          groupId,
          organizationId: this.currentOrganizationId
        })
        .then(response => this.setCurrentClass(response.data))
        .catch(() => warningMessage(this.$t('common.warnings.could_not_load_resource'))(this))

        return this.$router.push({
          name: 'class-details',
          params: {
            organizationId: this.currentOrganizationId,
            classId: groupId,
          }
        })
      },
      ...mapActions('classes', [
        'getClasses',
        'getClass',
        'setCurrentClass',
      ])
    },
    computed: {
      orgType () {
        return 'school'
      },
      classes() {
        return slice(0, 3, this.getClassList || [])
      },
      classesLength: compose(length, propOr([], 'getClassList')),
      ...mapGetters('classes', [
        'getClassList'
      ]),
      ...mapGetters('organization', [
        'currentOrganizationId',
      ]),
    },
    watch: {
      '$route.params.organizationId': {
        immediate: true,
        handler () {
          return this.getClasses()
      }}
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  .class-overview {

  }

  .dashboard-card {
    ::v-deep .card {
      height: 100%;
    }
  }

  .el-row {
    flex-wrap: wrap;
    padding-bottom: 36px;
  }

  .el-col {
    padding-top: 32px;
    overflow: hidden;
  }

  .class-card-heading {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;

    h3 {
      margin: 0px;
      font-weight: bold;
      font-size: 16px;
      letter-spacing: 0.03em;
      text-transform: uppercase;

      color: $darker-blue;
    }
  }

  .class-summary, .other-classes {
    padding-top: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      padding-right: 16px;
    }

    div {
      display: flex;
      flex-direction: column;
    }
  }

  .router-link-exact-active {
    font-weight: 600;
    font-size: 14px;
    text-decoration-line: underline;
    text-transform: capitalize;
    color: $blue;
  }

  .student-number, .class-number {
    font-weight: bold;
    font-size: 28px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: $darker-blue;
    mix-blend-mode: normal;
  }

  .students, .classes {
    font-weight: normal;
    font-size: 16px;
    text-transform: capitalize;
    color: $darker-blue;
  }

  .other-classes {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    > div {
      display: flex;
      flex-direction: row;
      padding-bottom: 24px;

      > div {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .classes-students {
          display: flex;
          flex-direction: row;
          align-items: center;

          span {
            padding-right: 8px;
          }
        }
      }
    }
  }

  .other-classes > div > div .classes-students, .card .class-card-heading {
    p.link {
      font-weight: 600;
      text-decoration-line: underline;
      color: $blue;
      mix-blend-mode: normal;
      cursor: pointer;
    }
  }

  .other-classes > div > div .classes-students a {
    font-size: 12px;
  }

   .card .class-card-heading a {
    font-size: 14px;
  }
</style>
